import { render, staticRenderFns } from "./listAssignedServices.vue?vue&type=template&id=6ce38e0c"
import script from "./listAssignedServices.vue?vue&type=script&lang=js"
export * from "./listAssignedServices.vue?vue&type=script&lang=js"
import style0 from "./listAssignedServices.vue?vue&type=style&index=0&id=6ce38e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports